import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Modal from '@ublique/components/LoadingModal'
import { DatePicker } from '@ublique/components/DatePicker'
import useDateTimeFormat from 'utils/hooks/useDateTimeFormat'
import moment from 'moment'
import { first, isEmpty } from 'lodash'

import './index.scss'

const SimulateModal = ({ open, close, data: { onSubmit, t } }) => {
  const { t: tCommon, i18n } = useTranslation('Common')
  const { dateFormat } = useDateTimeFormat()
  const [value, setValue] = useState()

  const onRequestSubmit = () => {
    const payload = { dataToSimulate: value }
    onSubmit(payload)
    close()
  }

  const onChange = (eventOrDates) => {
    const date = eventOrDates.target
      ? eventOrDates.target.value
      : eventOrDates[0]

    const formattedDate = moment(date).format('YYYY-MM-DD')
    setValue(formattedDate)
  }

  return (
    <Modal
      open={open}
      onRequestClose={close}
      modalHeading={t('SimulateModal.HEADING')}
      className='simulate-scenario-modal'
      onRequestSubmit={onRequestSubmit}
      primaryButtonText={t('SimulateModal.CTA')}
      secondaryButtonText={tCommon('Cancel')}
      primaryButtonDisabled={isEmpty(value)}
      preventCloseOnClickOutside
      size='xs'
    >
      <DatePicker
        dateFormat={dateFormat.altValue}
        onChange={onChange}
        datePickerType='single'
        value={new Date(value)}
        locale={first(i18n.language.split('-'))}
      >
        <DatePicker.Input
          id='simulate-date'
          placeholder='yyyy/mm/dd'
          pattern={dateFormat.pattern || null}
        />
      </DatePicker>
    </Modal>
  )
}

export default SimulateModal
